module.exports = __webpack_public_path__ + "img/reset.c236f1ba.svg";